<div class="pg-layer ui-scroll-vertical sm-scrollbar" id="pgLayoutContent">
  <div class="pg-header">
    <shared-page-header></shared-page-header>
  </div>
  <div class="pg-content">
    <div class="row">
      <shared-instruments></shared-instruments>
    </div>

    <div class="row">
      <div class="pg-wrapper">
        <div class="grid align-items-start"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">
          <div class="col-6 col-md-6 col-sm-12 no-padding">
            <shared-main-banners [MainBannersView]="MBType.NewsGallery"></shared-main-banners>
          </div>
          <div class="col-6 col-md-6 col-sm-12 no-padding">
            <shared-main-banners [MainBannersView]="MBType.VerticalBanner"></shared-main-banners>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="pg-wrapper">
        <shared-main-news></shared-main-news>
      </div>
    </div>

    <div class="row">
      <div class="pg-wrapper">
        <div class="grid align-items-start">
          <div class="col-12 no-padding">
            <shared-crowdfunding [CrowdfundingView]="CVType.About"></shared-crowdfunding>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="pg-wrapper">
        <div class="grid align-items-start"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">
          <div class="col-6 col-sm-12 no-padding">
            <shared-crowdfunding [CrowdfundingView]="CVType.Helper"></shared-crowdfunding>
          </div>
          <div class="col-6 col-sm-12 no-padding">
            <shared-crowdfunding [CrowdfundingView]="CVType.Donate"></shared-crowdfunding>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pg-footer">
    <shared-page-footer></shared-page-footer>
  </div>
  <div class="ui-background__pg-header"></div>
  <div class="ui-background__pg-content"></div>
  <div class="ui-background__pg-footer"></div>
</div>

<shared-page-mobile-menu></shared-page-mobile-menu>
<shared-page-mobile-profile></shared-page-mobile-profile>
<shared-cookies-contract></shared-cookies-contract>
